import { getUserId } from '../../auth';
import { safeAccess } from '../../utils';

export const getContributionSetupData = (state) =>
  safeAccess(state, `contributionSetup.cache[${getUserId(state)}]`, {});
